'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NextController = exports.NextController = function () {
    function NextController($log, $q, $timeout, FlickityConfig, FlickityService) {
        'ngInject';

        _classCallCheck(this, NextController);

        this.$log = $log;
        this.$q = $q;
        this.$timeout = $timeout;
        this.FlickityConfig = FlickityConfig;
        this.FlickityService = FlickityService;

        this._activate();
    }

    _createClass(NextController, [{
        key: '_activate',
        value: function _activate() {
            // Assign or fall back to default
            this.wrapAround = this.bcFlickityNext || this.FlickityConfig.wrapAround;
            this.flickityId = null;

            // Make sure we have an ID
            this._setId();
        }

        /**
         * Set ID to what is defined, fallback to first instance
         *
         * @return {String} flickityId
         */

    }, {
        key: '_setId',
        value: function _setId() {
            var _this = this;

            return this.$q(function (resolve, reject) {

                if (_this.bcFlickityId) {
                    _this.flickityId = _this.bcFlickityId;
                    resolve(_this.flickityId);
                } else {
                    _this.$timeout(function () {
                        _this.FlickityService.getFirst().then(function (instance) {
                            _this.flickityId = instance.id;
                            resolve(_this.flickityId);
                        }).catch(function (error) {
                            _this.$log.warn(error);
                            reject(error);
                        });
                    });
                }
            });
        }
    }]);

    return NextController;
}();


/** WEBPACK FOOTER **
 ** ./src/next/next.controller.js
 **/